import * as React from 'react';
import { withRouter, BrowserHistory } from "react-router-dom";
import { observable, action, computed, runInAction } from 'mobx';
import { observer } from 'mobx-react';
import { CircularProgress, Button, TextField, Card, CardText, CardTitle, CardActions, Snackbar } from 'react-md';
import { IApi } from '../../utility/IApi';
import { IInputValidator } from '../../utility/IInputValidator';

export class ExecuteResetPasswordModel {
    @observable asyncOperationsCount = 0;
    @observable errorMessages: string[] = [];
    @observable requestExecuted: boolean = false;
    @observable passwordError: boolean = false;
    @observable confirmPasswordError: boolean = false;
    @observable typedPassword: string = "";
    @observable typedConfirmPassword: string = "";

    @computed get submitDisabled() {
        return this.passwordError ||
               this.confirmPasswordError ||
               this.typedConfirmPassword.length === 0 ||
               this.typedPassword.length === 0;
    }
    private code: string = "";
    private api: IApi; 
    private validator: IInputValidator;
    constructor(api: IApi, validator: IInputValidator, code: string) {
        this.api = api;
        this.code = code;
        this.validator = validator;
    }
    @action.bound incrementAsyncOperations() {
        this.asyncOperationsCount = this.asyncOperationsCount + 1;
    }
    @action.bound decrementAsyncOperations() {
        this.asyncOperationsCount = this.asyncOperationsCount - 1;
    }
    @action onTextFieldChange(key: string, value: string) {
        switch (key) {
            case "password":
                this.typedPassword = value;
                this.passwordError = !this.validator.isValidPassword(value);
                break;
            case "confirmPassword":
                this.typedConfirmPassword = value;
                this.confirmPasswordError = !this.validator.isValidPassword(value) || 
                value !== this.typedPassword ;
                break;
            default:
                return;
        }
        
    }
    @action
    executeRequest() {
        this.incrementAsyncOperations();
        this.api.executeResetPassword(
            {
                code: this.code,
                password: this.typedPassword,
                password1: this.typedConfirmPassword
            }
        ).subscribe(
            response => {
                this.decrementAsyncOperations();
                runInAction( () => {
                    this.requestExecuted = true;
                });
            },
            error => {
                runInAction( () => {
                    this.decrementAsyncOperations();
                    this.errorMessages.splice(0, this.errorMessages.length);
                    this.errorMessages.push(error.message);
                });
            }
        );
    }
}

@observer class ExecuteResetPasswordView 
extends React.Component< {model: ExecuteResetPasswordModel, history: BrowserHistory}, {}> {

    render() {
        return(
            <div className="container">
                {
                    this.props.model.asyncOperationsCount > 0 &&
                    <CircularProgress  centered={true} id="Progress" />
                }
                
                {this.props.model.asyncOperationsCount === 0  &&
                !this.props.model.requestExecuted &&
                <form className="formContainer">
                <h1 className="header">Create New Password</h1>
                
                <div className="inputContianer">
          
                        <TextField
                            id="passwordInput"
                            helpText="Min. 8 Characters. At least 1 uppercase letter, 1 lowercase letter and 1 number."
                            required={true}
                            className="stackableTextInputRight"
                            error={this.props.model.passwordError}
                            fullWidth={false}
                            label="Password" 
                            type="password" 
                            onChange={(e) => this.props.model.onTextFieldChange("password", e.toString())}
                            value={this.props.model.typedPassword}
                        />
                  
                        <TextField
                            id="confirmPasswordInput"
                            className="stackableTextInputLeft"
                            helpText="Min. 8 Characters. At least 1 uppercase letter, 1 lowercase letter and 1 number."
                            fullWidth={false}
                            label="Confirm Password" 
                            error={this.props.model.confirmPasswordError}
                            required={true}
                            type="password" 
                            onChange={(e) => this.props.model.onTextFieldChange("confirmPassword", e.toString())}
                            value={this.props.model.typedConfirmPassword}
                        />
                  
                </div>
                
                <div>
                <Button
                    className="loginButton margin-top-10" 
                    disabled={this.props.model.submitDisabled}
                    secondary={true}
                    raised={true} 
                    onClick={(e) => {
                        this.props.model.executeRequest();
                        e.preventDefault(); }}
                >
                Confrim
                </Button>
                </div>
                
                </form>
                }
                {
                    this.props.model.asyncOperationsCount === 0 &&
                    this.props.model.requestExecuted &&
                    <Card className="">
                        <CardTitle 
                            title="Password Reset Completed" 
                            subtitle="Password has been reset successfully" 
                        />
                        <CardText className="">
                            <p>
                                You have successfully changed your account's password.
                                Go to Login to access your account. 
                            </p>
                        </CardText>
                        <CardActions className="md-divider-border md-divider-border--top">
                            <Button 
                                flat={true} 
                                secondary={true}
                                onClick={() => this.props.history.push("/login")}
                            >
                            Go To Login
                            </Button>
                        </CardActions>
                    </Card>
                }
                <Snackbar
                    id="errors-snackbar"
                    toasts={this.props.model.errorMessages.map(item => {
                        return {
                            text: item
                        };
                    })}
                    autohide={true}
                    onDismiss={() => {
                        this.props.model.errorMessages = [];
                    }}
                />

            </div>
        );
    }
}
export default withRouter(ExecuteResetPasswordView);


// WEBPACK FOOTER //
// ./src/view/ExecuteResetPassword/ExecuteResetPassword.tsx